<app-header></app-header>
<div class="menu">
    <div class="page-content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer></app-footer>
